import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { $getSelection, $isRangeSelection } from "lexical";
import { useEffect } from "react";
import { $createDividerNode } from "../nodes/divider-mui";
import { INSERT_DIVIDER_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

import type { InsertDividerCommand } from "../types/commands";

export const DividerPlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          INSERT_DIVIDER_COMMAND,
          (data: InsertDividerCommand) => {
            const selection = $getSelection();

            const node = $createDividerNode(editor._headless, data);

            if ($isRangeSelection(selection)) $insertNode(node);
            else selection?.insertNodes([node]);

            return true;
          },
          1,
        ),
      ),
    [editor],
  );

  return null;
};
